import Vue from "vue";
import App from "./App.vue";
import router from './router'
import 'primevue/resources/themes/rhea/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import ToastService from 'primevue/toastservice';

Vue.use(ToastService);

Vue.config.productionTip = false;

new Vue({
  
  router,
  render: h => h(App)
}).$mount("#app");
